module.exports = __webpack_public_path__ + "img/gustav-weber.4aa66cc9.png";